export default {
  /* Events */
  organizer: '组织者',
  eventRating: '活动等级',
  priceRating: '价格等级',
  profitability: '盈利能力',
  businessFee: '营业费',
  gatewayFee: '网关费',
  totalProfit: '总利润',
  tags: '标签',
  createTag: '创建标签',
  limitRegisterByIdentificationDocument: '通过身份证件限制注册',
  cover: '覆盖',
  pictures: '照片 |照片',
  eventCreated: '已创建事件',
  promoter: '促进',
  locationUrl: 'Url 到位置',
  facebookMessageSendingUrl: '发送 Url 的 Facebook 消息',
  facebookSiteUrl: 'Facebook 网站网址',
  completeRequiredFields: '完成所需字段',
  promoterSuccessfullyCreated: '已成功创建启动器',
  promoterSuccessfullyUpdated: '已成功更新发起人',
  eventSocialNetworks: '活动社交网络',
  socialNetworkSelect: '选择社交网络',
  restaurant: '餐廳',
  bar: '酒吧',
  hotel: '旅館',
  museum: '博物館',
  cultureHouse: '文化屋',
  park: '公園',
  gym: '健身房',
  comercialCenter: '購物中心',
  theatre: '劇院',
  cafe: '咖啡店',
  library: '圖書館',
  house: '屋',
  assistantsExportedSuccessfully: '已成功导出的助手',
  createEvent: '创建事件',
  mustChargeBeforeCreateEvents: '在创建活动之前，您必须向资金收费',
  events: '事件',
  published: '发表',
  notPublished: '未发布',
  soldOut: '售完',
  publishEventToBeShownInSalesLists: '发布此事件以显示在销售列表中',
  loadingEvents: '加载事件',
  noEventsRegistered: '未注册任何事件',
  publish: '发布',
  soldTickets: '已售门票',
  availableTickets: '可用门票',
  totalTickets: '门票金额',
  eventStateUpdated: '事件状态已更新',
  profileImage: '配置文件图像',
  thePicture: '图片',
  thePictures: '图片',
  theBanner: '横幅',
  purchase: '采购',
  /* End Events */
  /* Promotors */
  createPromotor: '创建推广人',
  mustChargeBeforeCreatingPromotors: '在创建促销员之前，您必须收取费用',
  promotors: '发起人',
  showUrlToPromotor: '向推广人显示 URL',
  editPromotor: '编辑推广商',
  setProfilePicture: '设置配置文件图片',
  setBanner: '设置横幅',
  deletePromotor: '删除促销员',
  loadingPromotor: '加载启动器',
  noPromotorsRegistered: '没有注册促销员',
  createProductsCategory: '创建产品',
  mustChargeBeforeCreatingProductsCategories: '在创建产品之前，您必须向资金收费',
  successfullyCreatedProductCategory: '产品创建成功',
  successfullyUpdatedProductCategory: '产品更新成功',
  newProductsCategory: '新产品',
  editProductsCategory: '编辑产品',
  photos: '照片',
  setProductsCategoryPhoto: '设置产品照片',
  deleteProductsCategory: '删除产品',
  loadingProductsCategory: '加载产品',
  noProductsCategoriesRegistered: '没有注册的产品',
  doYouWantToDeleteProductsCategory: '是否要删除产品？',
  price: '价格',
  discountPrice: '折扣价',
  stock: '股票',
  createProduct: '创建产品',
  mustChargeBeforeCreatingProducts: '在创建产品之前，您必须向资金收费',
  products: '产品',
  newProduct: '新产品',
  editProduct: '编辑产品',
  // // photos: '照片',
  setProductPhoto: '设置产品照片',
  deleteProduct: '删除产品',
  loadingProduct: '加载产品',
  noProductsRegistered: '没有注册的产品',
  doYouWantToDeleteProduct: '是否要删除产品？',
  provider: '供应商',
  providers: '供应商',
  createProvider: '创建提供程序',
  mustChargeBeforeCreatingProviders: '在创建提供商之前，您必须向资金收费',
  newProvider: '新提供商',
  editProvider: '编辑提供程序',
  deleteProvider: '删除提供程序',
  loadingProvider: '加载提供程序',
  noProvidersRegistered: '没有注册的提供程序',
  doYouWantToDeleteProvider: '是否要删除提供程序？',
  providerHasBeenDeleted: '已成功删除提供程序',
  fabric: '织物',
  fibre: '纤维',
  key: '关键',
  positionArc: '位置弧',
  acab: '阿卡布',
  acabado: '阿卡巴多',
  refChina: '参考中国',
  refClient: '参考客户端',
  label: '标签',
  wide: '宽',
  weight: '重量',
  composition: '组成',
  perfomance: '佩尔福曼斯',
  unitMeasure: '单位度量',
  cantMtsFinals: '山决赛',
  cantKlsFinals: '不能克尔斯决赛',
  cantMtKl: '茨特山克尔',
  capMaxKl: '帽最大Kl',
  portOcupation: '端口杯',
  // newProduct: 'Nuevo producto',
  // editProduct: 'Editar producto',
  // deleteProduct: 'Eliminar producto',
  // loadingProduct: 'Cargando productos',
  // noProductsRegistered: 'No hay productos registrados',
  // doYouWantToDeleteProduct: '¿Desea borrar el producto?'
  productHasBeenDeleted: '已成功删除产品',
  attachEventsInYourWebSite: '在网站中插入事件',
  createDivElementToAttachEventsInYourWebSite: '为了将事件附加到您的网站，您必须创建具有 id 的 div 元素',
  andOtherWithTheId: '和其他与 ID',
  inYourSiteBody: '在网站正文标签中',
  andThenAddTheNextScriptInTheFooter: '然后将下一个脚本添加到网站页脚',
  scriptCopied: '复制脚本',
  errorCopyingTheScript: '复制脚本错误',
  exportAssistants: '出口助理',
  assistantsList: '助理列表',
  assistantId: '助理 ID',
  loadingAssistants: '加载助手',
  noAssistantsRegistered: '没有注册的助手',
  registerDate: '注册日期',
  automatic: '自动',
  manual: '手动',
  creationType: '创建类型',
  errorLoadingEvent: '加载事件时出错',
  eventNotPublishedAndOutOfLists: '您的事件尚未发布，并且在列表中不会看到它，直到它',
  eventDate: '活动日期',
  publishEvent: '发布事件',
  seePromotorInYourWebSite: '在您的网站中查看推广人',
  mustDoToSeePromotorInWebSite: '要查看启动器，您必须确保在您的网站中附加事件小部件，以输入下一个 URL',
  copy: '复制',
  mustContactSupportToSeePromotorInWebSite: '要查看启动器，您必须联系支持人员才能获取 URL',
  errorCopyingUrl: '复制 URL 时出错',
  urlCopied: '复制的 Url',
  eventContacts: '事件联系人',
  doYouWantToDeletePromotor: '是否要删除促销员？',
  /* Djs */
  view: '看到',
  djSuccessfullyCreated: 'Dj成功建立',
  djSuccessfullyUpdated: 'Dj成功更新',
  createDj: '建立 dj',
  mustChargeBeforeCreatingDjs: '创作前必须先收钱djs',
  djs: 'Djs',
  followers: '追随者',
  showUrlToDj: '显示网址到dj',
  editDj: '主编dj',
  deleteDj: '删除dj',
  loadingDj: '加载djs',
  noDjsRegistered: '没有注册的djs',
  doYouWantToDeleteDj: '您要删除dj吗？',
  seeDjInYourWebSite: '在你的网站上看到dj',
  mustDoToSeeDjInWebSite: '为了看到的DJ，你必须确保有事件在您的网站附加的小部件，进入下一个url',
  mustContactSupportToSeeDjInWebSite: '为了看到dj，你必须联系支持，以获得一个网址。',
  /* End Djs */
  importAssistants: '导入助理',
  event: '事件',
  assistantsImportedSuccessfully: '已成功导入的助手',
  format: '格式',
  editEvent: '编辑事件',
  newEvent: '新事件',
  shortDescription: '简短描述',
  note: '注意',
  insertNoteToSendInConfirmationEmail: '插入要在确认电子邮件中发送的便笺',
  isAnOnlineEvent: '这是一个在线事件',
  eventUrl: '事件的 URL',
  category: '类别',
  startDate: '开始日期',
  finishDate: '完成日期',
  startDateAccess: '开始日期',
  finishDateAccess: '完成日期',

  /* Places */
  place: '地方',
  places: '地方',
  placeLocation: '地點坐標',
  cantFindPlace: '找不到地方？注册一个',
  canFindPlace: '有位置吗？选择一个',
  mustChargeBeforeCreatingPlaces: '創建地點之前，您必須先付款',
  newPlace: '建立地點',
  editPlace: '編輯地點',
  viewPlace: '看地方',
  setPlacePhoto: '上傳地點照片',
  deletePlace: '刪除地點',
  loadingPlace: '載入地點',
  noPlacesRegistered: '沒有註冊的地方',
  doYouWantToDeletePlace: '¿想要刪除這個地方嗎？',
  infoPlace: '地方的信息',
  placeSocialNetworks: '該地方的社交網絡',
  placeContacts: '放置聯繫人',
  ExpAndOffs: '經驗和優惠',
  experiences: '體會',
  trips: '遊記',
  concerts: '協奏曲',
  offerings: '優惠',
  veggie: '素食主義者',
  allergies: '過敏症',

  latitude: '纬度',
  longitude: '经度',

  eventTypeCamping: '露营，旅行或撤退',
  eventTypeAttraction: '景点',
  eventTypeRace: '耐力赛或赛事',
  eventTypeDinner: '晚餐或盛宴',
  eventTypeWorkshop: '课堂，课程或工作坊',
  eventTypeSignature: '外观或签名',
  eventTypeConcert: '音乐会或表演',
  eventTypeConference: '会议',
  eventTypeConvention: '惯例',
  eventTypeMeetup: '网络活动或会议',
  eventTypeFair: '交易会，消费者交易会或展览会',
  eventTypeFestival: '节日或公平',
  eventTypeParty: '聚会或社交聚会',
  eventTypeCompetition: '游戏或比赛',
  eventTypeOther: '其他',
  eventTypeProjection: '投影',
  eventTypeRally: '团结',
  eventTypeSeminar: '研讨会或演讲',
  eventTypeTournament: '比赛',
  eventTypeVisit: '访问',

  eventCategoryAcademic: '学校活动',
  eventCategoryHobbies: '爱好和特殊兴趣',
  eventCategoryArts: '表演艺术和视觉艺术',
  eventCategoryScience: '科学和技术',
  eventCategoryCinema: '电影，媒体和娱乐',
  eventCategoryCars: '汽车，轮船和飞机',
  eventCategoryCommunities: '社区与文化',
  eventCategorySports: '运动与健康',
  eventCategoryHolidays: '假期',
  eventCategoryFamily: '家庭与教育',
  eventCategoryGastronomy: '美食学',
  eventCategoryPolitics: '政府与政治',
  eventCategoryHousing: '家庭和生活方式',
  eventCategoryFashion: '时尚与美丽',
  eventCategoryMusic: '音乐',
  eventCategoryBusiness: '商业和专业服务',
  eventCategorySocial: '慈善组织和事业',
  eventCategoryOther: '其他',
  eventCategoryReligion: '宗教与灵性',
  eventCategoryHealth: '健康与保健',
  eventCategoryOutdoors: '旅行和户外活动',

  doYouWantDuplicate: '您要复制这个地方吗？',
  isPlaceActive: '这个地方活跃吗？',
  isThisPlaceRestaurant: '这个地方是餐厅',
  configPlace: '放置配置',
  placeRating: '地方排名',
  placeTags: '您所在位置的标签',
  tagsHint: '输入日期，然后按 Enter',
  pleaseTypeLocation: '请输入您的地址',
  diningStyle: '餐饮风格',
  dressCode: '著裝規範',
  acceptedPaymentMethods: '可接受的付款方式',
  parkingType: '停車類型',
  casual: 'Casual',
  businessCasual: 'Business casual',
  casualElegant: 'Casual elegant',
  formal: 'Formal',
  jacketRequired: 'Jacket required',
  jacketAndTie: 'Jacket and tie',
  priceAverage: '平均价格',
  brunch: '早午餐',
  lunch: '午餐',
  happyHour: '欢乐时光',
  dinner: '晚餐',
  daily: '日常',
  /* End Places */

  urlOrLink: 'URL 或链接',
  socialNetworkAdd: '添加社交网络',
  eventCurrency: '事件币种',
  ticketTitle: '门票标题',
  ticketPrice: '票价',
  ticketingServicePrice: '票务服务价格',
  startOfSale: '开始销售',
  endOfSale: '销售结束',
  ticketsNumber: '门票数量',
  maxTicketsPerPerson: '每人最多的门票数量',
  deleteTicket: '删除票证',
  addTicket: '添加票证',
  result: '结果',
  ofPromoter: '发起人',
  upload: '上传',
  allowedFormats: '仅允许这些格式',
  maxPictureSize: '图片的最大大小必须为',
  and: '和',
  dragAndDropFile: '在此处拖放文件',
  imageSuccessfullyLoaded: '已成功加载图像',
  deleteSelection: '删除选择',
  analyze: '分析',
  atLeastOneFileToContinue: '输入至少一个文件以继续',
  nextStep: '下一步',
  theFile: '文件',
  notAccepted: '未被接受',
  seeEvent: '查看事件',
  registerAttender: '注册助理',
  advancedSearch: '高级搜索',
  assistantsPerPage: '每页助理',
  assistantName: '助理姓名',
  creation: '创造',
  ticket: '票',
  register: '注册',
  assistantRegistered: '已登记的助理',
  buyer: '买方',
  cost: '成本',
  parallelAnswer: '并行答案',
  franchise: '专营',
  bank: '银行',
  ofPurchase: '购买',
  download: '下载',
  dataCopied: '复制的数据',
  errorTryAgain: '发生错误，请重试',
  checkInState: '签入状态',
  check: '检查',
  checkedIn: '入住',
  unCheck: '取消',
  zipCode: '邮政编码',
  currency: '货币'
}
